import { Segment } from "@mui/icons-material";
import { Button } from "antd";
import styled from "styled-components";
import { LogoSVG } from "../../assets/svg/Svgs";
import { APP_NAME, APP_URL, REGISTER_URL } from "../../constants/constants";
import { MobileMenu } from "./MobileMenu";
import { useLocation } from "react-router-dom";

export const AppBar = () => {
  const location = useLocation();

  const menuItems = () => {
    return navMenu.map((item, i) => (
      <MenuItem data={item} key={i} location={location} />
    ));
  };
  return (
    <div>
      <Wrapper className="x100">
        <InnerWrapper className="container flexSpaceCenter y100">
          {/* LOGO */}
          <img src={LogoSVG} height={40} alt={APP_NAME} />
          {/* MENU */}
          <MenuWrapper className="flexNullCenter font13 desktop">
            {menuItems()}
          </MenuWrapper>

          {/* END */}
          <ActionWrapper className="flex gap20 desktop">
            <Button type="primary" href={REGISTER_URL} target="_blank">
              Sign Up
            </Button>
            <Button href={APP_URL} target="_blank">
              Login
            </Button>
          </ActionWrapper>

          {/* MOBILE */}
          <div className="mobile">
            <MobileMenu
              action={
                <OptionsButton className="r10 flexCenter">
                  <Segment />
                </OptionsButton>
              }
            >
              <div className="flexColumn gap30">{menuItems()}</div>
            </MobileMenu>
          </div>
        </InnerWrapper>
      </Wrapper>
      <div style={{ height: 80 }} />
    </div>
  );
};

const MenuItem = ({ data, location }) => {
  const { label, path } = data || {};
  const isScrollLink = path.startsWith("#");
  const isLanding = window.location.pathname === "/";
  const finalPath = isScrollLink && !isLanding ? `/${path}` : path;

  const isSelected =
    (location.pathname + location.hash).replace("/", "") ===
    finalPath.replace("/", "");

  return (
    <a
      className={`pointer black ${isSelected ? "main semiBold" : ""}`}
      href={finalPath}
    >
      {label}
    </a>
  );
};

const navMenu = [
  {
    label: "Home",
    path: "#home",
  },
  {
    label: "Blog",
    path: "/blog",
  },
  // {
  //   label: "Benefits",
  //   path: "",
  // },
  // {
  //   label: "Resource Centre",
  //   path: "",
  // },
  // {
  //   label: "Pricing",
  //   path: "",
  // },
  {
    label: "FAQs",
    path: "#faqs",
  },

  {
    label: "Reach Us",
    path: "#footer",
  },
];

const Wrapper = styled.div`
  border-bottom: 1px solid #eee;
  height: 70px;
  position: fixed;
  background-color: rgb(255 255 255 / 80%);
  backdrop-filter: blur(5px);
  top: 0;
  left: 0;
  z-index: 1000;

  .mobile {
    display: none;
  }

  @media (max-width: 960px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
    }
  }
`;
const InnerWrapper = styled.div`
  position: relative;
  padding: 0 20px;
`;
const ActionWrapper = styled.div``;

const OptionsButton = styled.div`
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
`;

const MenuWrapper = styled.div`
  gap: 40px;
`;
